import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  as?: "div" | "article" | "li";
}

export function Card({ children, className, hover = true, as = "div" }: CardProps) {
  const reduce = useReducedMotion();
  const cls = cn(
    "rounded-xl border bg-surface p-5 transition duration-200",
    hover && "hover:-translate-y-1 hover:shadow-glow hover:border-primary/40",
    className,
  );

  return (
    <motion.div
      layout={false}
      whileHover={reduce || !hover ? undefined : { y: -4 }}
      transition={{ type: "spring", stiffness: 320, damping: 24 }}
      className={cls}
      role={as === "article" ? "article" : undefined}
    >
      {children}
    </motion.div>
  );
}
